import { User } from "oidc-client-ts";
import { getCurrentOrg } from "../fvid-auth/userSession";

interface PendoInitOptions {
  visitor: {};
  account: {};
}

declare global {
  interface Window {
    pendo: {
      initialize: (options: PendoInitOptions) => void;
    };
  }
}

const { pendo } = window;

const pendoInitialize = (user: User | null) => {
  if (pendo) {
    const org = getCurrentOrg();
    const visitorEmail = user?.profile?.email;
    pendo.initialize({
      visitor: {
        id: visitorEmail,
        app: window.location.origin,
      },
      account: {
        id: org?.orgId,
        name: org?.name,
      },
    });
  }
};

// eslint-disable-next-line import/prefer-default-export
export { pendoInitialize };
